<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title">Skicka påminnelsemail</p>
			</header>
			<section class="modal-card-body">
				<div v-if="mailRecievers.length < 1">
					Vill du skicka ett påminnelsemail för {{ itemTypeSwe }}:
					{{ item.name }}?
				</div>
				<div v-if="mailRecievers.length > 0">
					Mail skickat till:
					<div v-for="(user, index) in mailRecievers" :key="index">
						{{ user }}
					</div>
				</div>
				<div v-if="mailSent">
					Mail skickat
				</div>
			</section>
			<footer class="modal-card-foot">
				<button class="button is-dark" @click.prevent="sendMail" :disabled="disabledSendMail">
					<span v-if="!showSpinner" class="icon"><i class="fas fa-envelope" /></span>
					<span v-if="!showSpinner">Skicka mail</span>
					<Spinner :showSpinner="showSpinner" />
				</button>
				<button class="button is-dark" @click="cancel">
					<span class="icon"><i class="fas fa-ban" /></span>
					<span>Stäng</span>
				</button>
			</footer>
		</div>
	</div>
</template>

<script>
import Spinner from '@/components/Spinner';
import { mapActions } from 'vuex';
export default {
	components: {
		Spinner
	},
	props: {
		item: {
			type: Object,
			default: () => ({})
		},
		type: String
	},
	data: () => ({
		disabledSendMail: false,
		showSpinner: false,
		mailRecievers: [],
		mailSent: false
	}),
	computed: {
		itemType() {
			return this.type || 'ERROR';
		},
		itemTypeSwe() {
			if (this.type === 'round') {
				return 'ronden';
			}

			if (this.type === 'flaw') {
				return 'bristen';
			}

			return 'ERROR';
		}
	},
	methods: {
		...mapActions('roundPlanningStore', {
			triggerRoundMail: 'triggerMail'
		}),
		...mapActions('flawStore', {
			triggerFlawMail: 'triggerMail'
		}),
		sendMail() {
			this.showSpinner = true;
			this.disabledSendMail = !this.disabledSendMail;

			if (this.itemType === 'round') {
				this.triggerRoundMail(this.item.id).then(res => {
					this.mailRecievers = res;
					this.showSpinner = false;
				});
			} else if (this.itemType === 'flaw') {
				this.triggerFlawMail(this.item.id).then(res => {
					this.mailRecievers = res;
					this.mailSent = true;
					this.showSpinner = false;
				});
			}
		},
		confirm() {
			this.$emit('confirm');
		},
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
